import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider, useSelector } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider, theme } from "antd";
import { BrowserRouter } from "react-router-dom";

const Root = () => {
	const { currentUser } = useSelector((state) => state.user);

	const [primaryColor, setPrimaryColor] = useState("#159aff");
	const [fontFamily, setFontFamily] = useState("Helvetica, Arial, sans-serif");
	const [lightMode, setLightMode] = useState(true);

	useEffect(() => {
		const themeMode = localStorage.getItem("themeMode") ?? "light";
		setLightMode(themeMode === "light");
		document.body.className = themeMode;

		const primary =
			localStorage.getItem(
				themeMode === "light" ? "primary-color" : "dark_primary-color"
			) ?? "#159aff";
		const font =
			localStorage.getItem("font-family") ?? "Helvetica, Arial, sans-serif";
		setPrimaryColor(primary);
		setFontFamily(font);
	}, []);

	const toggleMode = () => {
		const newMode = !lightMode;
		setLightMode(newMode);
		const modeStr = newMode ? "light" : "dark";
		localStorage.setItem("themeMode", modeStr);
		document.body.className = modeStr;
	};

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: primaryColor,
					fontFamily: fontFamily,
				},
				algorithm: lightMode
					? [theme.defaultAlgorithm, theme.compactAlgorithm]
					: [theme.darkAlgorithm, theme.compactAlgorithm],
			}}
		>
			<PersistGate loading={null} persistor={persistor}>
				<App />
				{currentUser && (
					<div
						onClick={toggleMode}
						style={{
							position: "fixed",
							left: "1px",
							bottom: "10px",
							zIndex: 9999,
							cursor: "pointer",
						}}
					>
						{lightMode ? "🌞" : "🌙"}
					</div>
				)}
			</PersistGate>
		</ConfigProvider>
	);
};

const rootElement = document.getElementById("root");
ReactDOM.createRoot(rootElement).render(
	<Provider store={store}>
		<BrowserRouter
			future={{
				v7_startTransition: true,
				v7_relativeSplatPath: true,
			}}
		>
			<Root />
		</BrowserRouter>
	</Provider>
);
